import noodleApiClient, { ApiDefinition } from '@noodleApi';

type ThisApi = ApiDefinition['/invoices/{invoiceId}/payment-plans/{paymentPlanId}']['PUT'];
type Input = ThisApi['body'] & ThisApi['params'];

const editInstallment = async ({ invoiceId, paymentPlanId, ...body }: Input): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.put(`/invoices/${invoiceId}/payment-plans/${paymentPlanId}`, body);
  return response.data;
};

export default editInstallment;
